import React from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Container,
  CssBaseline,
  Grid,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {
  ValidatorForm,
  TextValidator
} from "react-material-ui-form-validator";
import { Button } from "../../../../components/Wrappers/Wrappers";
import Select2 from 'react-select';

const AddWorkerDialog = (props) => {
  let {
    classes,
    formData,
    workerCreateModal,
    handleClose,
    handleChangeInput,
    handleChangeInputContractor,
    handleSubmit,
    contractors,
  } = props;

  let contractorListitemsTemp = contractors && contractors.length ? contractors.map((element) => ({ value: element.id, label: element.company_name })) : []

  return (
    <Dialog fullScreen open={workerCreateModal} onClose={handleClose}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Add New Worker
          </Typography>
          <Button color="inherit" onClick={handleClose}>
            Cancel
          </Button>
        </Toolbar>
      </AppBar>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Typography component="h1" variant="h5">
            Add Worker
          </Typography>

          <ValidatorForm onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextValidator
                  label="First Name*"
                  fullWidth
                  onChange={handleChangeInput}
                  name="firstName"
                  id="firstName"
                  value={formData.firstName}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextValidator
                  label="Last Name*"
                  id="lastName"
                  fullWidth
                  onChange={handleChangeInput}
                  name="lastName"
                  value={formData.lastName}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextValidator
                  label="Email*"
                  id="email"
                  fullWidth
                  onChange={handleChangeInput}
                  name="email"
                  value={formData.email}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextValidator
                  label="Password*"
                  id="password"
                  fullWidth
                  onChange={handleChangeInput}
                  name="password"
                  type="password"
                  value={formData.password}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextValidator
                  label="Contact No.*"
                  id="mobile"
                  fullWidth
                  onChange={handleChangeInput}
                  name="mobile"
                  value={formData.mobile}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextValidator
                  label="Address*"
                  id="address"
                  fullWidth
                  onChange={handleChangeInput}
                  name="address"
                  value={formData.address}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Grid>
              {/* <Grid item xs={12} sm={12}>
                <FormControl
                  className={"classes.formControl"}
                  style={{ width: "100%" }}
                >
                  <SelectValidator
                    label="Contractor*"
                    fullWidth
                    labelId="select-contractor-label"
                    id="select-contractor"
                    name="parentId"
                    value={formData.parentId}
                    onChange={handleChangeInput}
                    validators={["required"]}
                    errorMessages={["this field is required"]}
                  >
                    <MenuItem value={""}>Please Select</MenuItem>
                    {contractors &&
                      contractors.length > 0 &&
                      contractors.map((contractor) => {
                        return (
                          <MenuItem key={contractor.id} value={contractor.id}>
                            {contractor.company_name
                              ? contractor.company_name
                              : "n/a"}
                          </MenuItem>
                        );
                      })}
                  </SelectValidator>
                </FormControl>
              </Grid> */}

              <Grid item xs={12} sm={12} style={{ margin: "0px", width: '100%' }}>
                <label htmlFor="resourceList" style={{ color: 'grey' }}>Contractor</label>
                <Select2
                  width="full"
                  name="parentId"
                  id="parentId"
                  onChange={handleChangeInputContractor}
                  value={contractorListitemsTemp.filter(function (option) {
                    return option.value === formData.parentId;
                  })}
                  options={contractorListitemsTemp}
                  className="basic-multi-select width: 'full'"
                  classNamePrefix="Activities"
                />
              </Grid>

              <Grid item xs={12}></Grid>
            </Grid>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              className={classes.submit}
            >
              Save
            </Button>
          </ValidatorForm>
        </div>
      </Container>
    </Dialog>
  );
};

export default AddWorkerDialog;
